import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import MultiTenantLogin from "pages/Login/MultiTenantLogin";
import LoginForm from "pages/Login/LoginForm";
import ResetPassword from "pages/Login/ResetPassword";
import EmployeePortalLayout from "../layouts/EmployeePortalLayout";
import ContractorPortalLayout from "../layouts/ContractorPortalLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import EmployeeDashboard from "pages/EmployeePortal/Dashboard";
import ManageEmployeeProfile from "pages/EmployeePortal/ManageEmployeeProfile";
import ClockTime from "pages/EmployeePortal/ClockTime";
import EmployeeTimeOff from "pages/EmployeePortal/TimeOff";
import Paystubs from "pages/EmployeePortal/Paystubs";
import Documents from "pages/EmployeePortal/Documents";
import EmployeeAccount from "pages/EmployeePortal/Account";
import EmployeeBankAccount from "pages/EmployeePortal/BankAccount";
import EmployeeBenefits from "pages/EmployeePortal/Benefits";
import ContractorDashboard from "pages/ContractorPortal/Dashboard";
import ManageContractorProfile from "pages/ContractorPortal/Profile";
import ContractorClockTime from "pages/ContractorPortal/ClockTime";
import ContractorPayments from "pages/ContractorPortal/Payments";
import ContractorDocuments from "pages/ContractorPortal/Documents";
import ContractorAccount from "pages/ContractorPortal/Account";
import ContractorBankAccount from "pages/ContractorPortal/BankAccount";
import ManageCompany from "../pages/Dashboard/ManageCompany";
import TimeKeeping from "../pages/Dashboard/TimeKeeping";
import AddTimeCard from "../pages/Dashboard/AddTimeCard";
import StartNewPayroll from "../pages/Dashboard/StartNewPayroll";
import Employees from "../pages/Employees/Employees";
import ViewEmployees from "../pages/Employees/ViewEmployees";
import Contractor from "pages/Contractor/Contractor";
import ViewContractor from "pages/Contractor/ViewEmployees";
import AddEditEmployee from "pages/Employees/AddEditEmployee";
import AddEditContractor from "pages/Contractor/AddEditContractor";
import Benefits from "pages/Benefits/Benefits";
import AddEditCompanyBenefit from "pages/Benefits/AddEditCompanyBenefit";
import AddEditEmployeeBenefit from "pages/Benefits/AddEditEmployeeBenefit";
import Deductions from "pages/Deductions/Deductions";
import AddEditMcnBenefit from "pages/Deductions/AddEditMcnDeduction";
import AddEditChildSupportDeduction from "pages/Deductions/AddEditChildSupportDeduction";
import AddEditGarnishmentDeduction from "pages/Deductions/AddEditGarnishmentDeduction";
import Reports from "pages/Reports/Reports";
import { formatRoute } from "utils";
import routes from "constants/routes";
import AllReports from "pages/Reports/AllReports";
import AuthorizationDocs from "pages/Reports/AuthorizationDocs";
import CompanyTaxDocs from "pages/Reports/CompanyTaxDocs";
import ContractorTaxDocs from "pages/Reports/ContractorTaxDocs";
import EmployeeTaxDocs from "pages/Reports/EmployeeTaxDocs";
import AuditTrail from "pages/Reports/AuditTrail";
import TaxBracketAdmin from "pages/Dashboard/TaxBracketAdmin";
import AccountSettings from "pages/Dashboard/AccountSettings";
import SuperAdminLayout from "../layouts/SuperAdminLayout";
import RoleManagement from "pages/SuperAdmin/RoleManagement";
import FirmManagement from "pages/SuperAdmin/FirmManagement";
import PlanManagement from "pages/SuperAdmin/PlanManagement";
import Locations from "pages/Dashboard/Locations";
import BillingPage from "pages/Dashboard/BillingPage";
import TermsOfService from "pages/Legal/TermsOfService";
import AppProvider from "context/AppContext";
import TimeOff from "pages/TimeOff/TimeOff";
import PayrollDetailPage from "pages/Dashboard/PayrollDetailPage";
import Notifications from "pages/Notifications/Notifications";
import PendingOnboardings from "pages/Onboarding/PendingOnboardings";
import PrivateRoute from "components/PrivateRoute";
import FeatureRoute from "components/FeatureRoute";

const AppRoutes = () => {

    return (
        <AppProvider>
            <Router>
                <Routes>
                    {/* Login */}
                    <Route index element={<MultiTenantLogin />} />
                    <Route path={formatRoute(routes.LOGIN.HOME)} element={<MultiTenantLogin />} />
                    <Route path={`${formatRoute(routes.LOGIN.HOME)}/:type`} element={<LoginForm />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/terms" element={<TermsOfService />} />

                    <Route path="/" element={<PrivateRoute requiredRole="Company"><DashboardLayout /></PrivateRoute>}>
                        <Route index element={<Dashboard />} />

                        <Route path={formatRoute(routes.DASHBOARD.HOME)}>
                            <Route index element={<Dashboard />} />
                            <Route path={formatRoute(routes.DASHBOARD.MANAGE_COMPANY)} element={<ManageCompany />} />
                            <Route path={formatRoute(routes.DASHBOARD.PAYROLL_TIME_KEEPING.HOME)}>
                                <Route index element={<TimeKeeping />} />
                                <Route path={formatRoute(routes.DASHBOARD.PAYROLL_TIME_KEEPING.ADD_TIME_CARD)} element={<AddTimeCard />} />
                            </Route>
                            <Route path={formatRoute(routes.DASHBOARD.START_NEW_PAYROLL)} element={<StartNewPayroll />} />
                            <Route path="payroll/:id" element={<PayrollDetailPage />} />
                            <Route path="account-settings" element={<AccountSettings />} />
                        </Route>



                        <Route path={formatRoute(routes.EMPLOYEES.HOME)}>
                            <Route index element={<FeatureRoute featureKey="manage_employees"><Employees /></FeatureRoute>} />
                            <Route path={formatRoute(routes.EMPLOYEES.VIEW)} element={<FeatureRoute featureKey="manage_employees"><ViewEmployees /></FeatureRoute>} />
                            <Route path={formatRoute(routes.EMPLOYEES.ADD_EDIT_EMPLOYEE)} element={<FeatureRoute featureKey="manage_employees"><AddEditEmployee /></FeatureRoute>} />
                        </Route>

                        <Route path={formatRoute(routes.CONTRACTOR.HOME)}>
                            <Route index element={<FeatureRoute featureKey="manage_contractors"><Contractor /></FeatureRoute>} />
                            <Route path={formatRoute(routes.CONTRACTOR.VIEW)} element={<FeatureRoute featureKey="manage_contractors"><ViewContractor /></FeatureRoute>} />
                            <Route path={formatRoute(routes.CONTRACTOR.ADD_EDIT_CONTRACTOR)} element={<FeatureRoute featureKey="manage_contractors"><AddEditContractor /></FeatureRoute>} />
                        </Route>

                        <Route path={formatRoute(routes.BENEFITS.HOME)}>
                            <Route index element={<FeatureRoute featureKey="benefits"><Benefits /></FeatureRoute>} />
                            <Route path={formatRoute(routes.BENEFITS.ADD_EDIT_COMPANY_BENEFIT)} element={<FeatureRoute featureKey="benefits"><AddEditCompanyBenefit /></FeatureRoute>} />
                            <Route path={formatRoute(routes.BENEFITS.ADD_EDIT_EMPLOYEE_BENEFIT)} element={<FeatureRoute featureKey="benefits"><AddEditEmployeeBenefit /></FeatureRoute>} />
                        </Route>

                        <Route path={formatRoute(routes.DEDUCTIONS.HOME)}>
                            <Route index element={<FeatureRoute featureKey="deductions"><Deductions /></FeatureRoute>} />
                            <Route path={formatRoute(routes.DEDUCTIONS.ADD_EDIT_MCN_DEDUCTION)} element={<FeatureRoute featureKey="deductions"><AddEditMcnBenefit /></FeatureRoute>} />
                            <Route path={formatRoute(routes.DEDUCTIONS.ADD_EDIT_CHILD_SUPPORT_DEDUCTION)} element={<FeatureRoute featureKey="deductions"><AddEditChildSupportDeduction /></FeatureRoute>} />
                            <Route path="add-edit-garnishment-deduction" element={<FeatureRoute featureKey="deductions"><AddEditGarnishmentDeduction /></FeatureRoute>} />
                        </Route>

                        <Route path={formatRoute(routes.TIME_OFF.HOME)} element={<FeatureRoute featureKey="time_off"><TimeOff /></FeatureRoute>} />
                        <Route path="dashboard/locations" element={<FeatureRoute featureKey="location_management"><Locations /></FeatureRoute>} />
                        <Route path="dashboard/billing" element={<FeatureRoute featureKey="billing"><BillingPage /></FeatureRoute>} />
                        <Route path={formatRoute(routes.NOTIFICATIONS.HOME)} element={<Notifications />} />
                        <Route path={formatRoute(routes.ONBOARDING.HOME)} element={<FeatureRoute featureKey="user_management"><PendingOnboardings /></FeatureRoute>} />

                        <Route path={formatRoute(routes.REPORTS.HOME)}>
                            <Route index element={<FeatureRoute featureKey="reports"><Navigate to={formatRoute(routes.REPORTS.ALL_REPORTS)} replace /></FeatureRoute>} />
                            <Route element={<FeatureRoute featureKey="reports"><Reports /></FeatureRoute>}>
                                <Route path={formatRoute(routes.REPORTS.ALL_REPORTS)} element={<AllReports />} />
                                <Route path={formatRoute(routes.REPORTS.AUTHORIZATION_DOCS)} element={<AuthorizationDocs />} />
                                <Route path={formatRoute(routes.REPORTS.COMPANY_TAX_DOCS)} element={<CompanyTaxDocs />} />
                                <Route path={formatRoute(routes.REPORTS.CONTRACTOR_TAX_DOCS)} element={<ContractorTaxDocs />} />
                                <Route path={formatRoute(routes.REPORTS.EMPLOYEE_TAX_DOCS)} element={<EmployeeTaxDocs />} />
                                <Route path={formatRoute(routes.REPORTS.AUDIT_TRAIL)} element={<AuditTrail />} />
                            </Route>
                        </Route>
                    </Route>

                    {/* Employee Portal */}
                    <Route path={formatRoute(routes.EMPLOYEE_PORTAL.HOME)} element={<PrivateRoute requiredRole="Employee"><EmployeePortalLayout /></PrivateRoute>}>
                        <Route index element={<EmployeeDashboard />} />
                        <Route path={formatRoute(routes.EMPLOYEE_PORTAL.PROFILE)} element={<ManageEmployeeProfile />} />
                        <Route path={formatRoute(routes.EMPLOYEE_PORTAL.CLOCK_TIME)} element={<ClockTime />} />
                        <Route path={formatRoute(routes.EMPLOYEE_PORTAL.TIME_OFF)} element={<EmployeeTimeOff />} />
                        <Route path={formatRoute(routes.EMPLOYEE_PORTAL.PAYSTUBS)} element={<Paystubs />} />
                        <Route path={formatRoute(routes.EMPLOYEE_PORTAL.DOCUMENTS)} element={<Documents />} />
                        <Route path={formatRoute(routes.EMPLOYEE_PORTAL.ACCOUNT)} element={<EmployeeAccount />} />
                        <Route path={formatRoute(routes.EMPLOYEE_PORTAL.BANK_ACCOUNT)} element={<EmployeeBankAccount />} />
                        <Route path={formatRoute(routes.EMPLOYEE_PORTAL.BENEFITS)} element={<EmployeeBenefits />} />
                    </Route>

                    {/* Super Admin Portal */}
                    <Route path={formatRoute(routes.SUPER_ADMIN.HOME)} element={<PrivateRoute requiredRole="SuperAdmin"><SuperAdminLayout /></PrivateRoute>}>
                        <Route index element={<FirmManagement />} />
                        <Route path="firms" element={<FirmManagement />} />
                        <Route path="plans" element={<PlanManagement />} />
                        <Route path="roles" element={<RoleManagement />} />
                        <Route path={formatRoute(routes.SUPER_ADMIN.TAX_BRACKETS)} element={<TaxBracketAdmin />} />
                    </Route>

                    {/* Contractor Portal */}
                    <Route path={formatRoute(routes.CONTRACTOR_PORTAL.HOME)} element={<PrivateRoute requiredRole="Contractor"><ContractorPortalLayout /></PrivateRoute>}>
                        <Route index element={<ContractorDashboard />} />
                        <Route path={formatRoute(routes.CONTRACTOR_PORTAL.PROFILE)} element={<ManageContractorProfile />} />
                        <Route path={formatRoute(routes.CONTRACTOR_PORTAL.CLOCK_TIME)} element={<ContractorClockTime />} />
                        <Route path={formatRoute(routes.CONTRACTOR_PORTAL.PAYMENTS)} element={<ContractorPayments />} />
                        <Route path={formatRoute(routes.CONTRACTOR_PORTAL.DOCUMENTS)} element={<ContractorDocuments />} />
                        <Route path={formatRoute(routes.CONTRACTOR_PORTAL.ACCOUNT)} element={<ContractorAccount />} />
                        <Route path={formatRoute(routes.CONTRACTOR_PORTAL.BANK_ACCOUNT)} element={<ContractorBankAccount />} />
                    </Route>
                </Routes>
            </Router>
        </AppProvider>
    );
};

export default AppRoutes;



